'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNASSIGNED = exports.UNASSIGNED = 'UNASSIGNED';
var USERS_AND_TEAMS = exports.USERS_AND_TEAMS = 'USERS_AND_TEAMS';
var OWNER = exports.OWNER = 'OWNER';
var INBOX_USERS = exports.INBOX_USERS = 'INBOX_USERS';
var BOT = exports.BOT = 'BOT';